module.exports = __webpack_public_path__ + "assets/img/63e4-tr.svg";